
let TargetService = function (Restangular) {
  const Service = Restangular.all('admin/target_group');

  let count = (query) => {
    return Service.customGET('count', query);
  } 

  let save = (resource) => {
    if (resource.save) {
        return resource.save();
    } else {
        return Service.post(resource);
    }
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Service.getList(query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let updatePosition = (id, data) => {
    return Service.customPATCH(data, `position/${id}`);
  };

  let destroy = ({id}) => {
    return Service.customDELETE(id);
  } 

  let downloadReport = () => { 
    return Restangular.one('target_group/report').get()
  }

  return { index, load, save, show, updatePosition, destroy, downloadReport } ;
};

TargetService.$inject = ['Restangular'];

export default TargetService;
 


// WEBPACK FOOTER //
// ./client/app/components/target/target.service.js